/**
 * CreditChangeModal — انتقال موارد استفاده منبع اعتباری به منبع دیگر
 */
import React, { useState, useEffect, useCallback } from 'react';
import { ui } from '../../components/ListPage';
import { jsonOf, netErr } from '../../utils/http';

const toFarsi = n => String(n).replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);

const API = (path, opts={}) => fetch(`/api/accounting${path}`, {
  headers: { 'Content-Type':'application/json', Authorization:`Bearer ${localStorage.getItem('access')}` },
  ...opts,
}).then(jsonOf, netErr);

export default function CreditChangeModal({ creditId, creditTitle, year, onClose, onChanged }) {
  const [countYear, setCountYear] = useState(0);
  const [countAll, setCountAll]   = useState(0);
  const [title, setTitle]         = useState('');
  const [thisYear, setThisYear]   = useState(true);
  const [loading, setLoading]     = useState(true);
  const [error, setError]         = useState('');
  const [saving, setSaving]       = useState(false);
  const [done, setDone]           = useState(false);
  const [changed, setChanged]     = useState(0);

  // جستجوی جایگزین
  const [q, setQ]             = useState('');
  const [results, setResults] = useState([]);
  const [target, setTarget]   = useState(null);
  const [searching, setSearching] = useState(false);

  // شمارش موارد استفاده
  useEffect(() => {
    (async () => {
      setLoading(true);
      const j = await API(`/credits/${creditId}/uses/?year=${year}`);
      setLoading(false);
      if (j.ok) {
        setCountYear(j.count_year);
        setCountAll(j.count_all);
        if (j.count_all === 0) setError('هیچ مورد استفاده‌ای از این منبع اعتباری وجود ندارد');
      } else setError(j.msg);
    })();
  }, [creditId, year]);

  // جستجوی منبع جایگزین
  const doSearch = useCallback(async (txt) => {
    if (!txt || txt.length < 1) { setResults([]); return; }
    setSearching(true);
    const j = await API(`/credits/lookup/?q=${encodeURIComponent(txt)}&exclude=${creditId}`);
    setSearching(false);
    if (j.ok) setResults(j.rows);
  }, [creditId]);

  useEffect(() => {
    const t = setTimeout(() => doSearch(q), 300);
    return () => clearTimeout(t);
  }, [q, doSearch]);

  // انجام انتقال
  const doMove = async () => {
    if (!target) { setError('منبع اعتبار جایگزین انتخاب نشده'); return; }
    setSaving(true); setError('');
    const j = await API(`/credits/${creditId}/change-uses/`, {
      method: 'POST',
      body: JSON.stringify({ target_id: target.id, this_year: thisYear, year }),
    });
    setSaving(false);
    if (j.ok) { setDone(true); setChanged(j.changed); if (onChanged) onChanged(); }
    else setError(j.msg);
  };

  const usable = countAll > 0;

  return (
    <div style={ui.overlay} onClick={onClose}>
      <div style={{...ui.modal, maxWidth:'600px'}} onClick={e=>e.stopPropagation()}>
        {/* هدر */}
        <div style={{...ui.mHeader, background:'linear-gradient(135deg,#1a237e,#283593)'}}>
          <div style={ui.mTitle}>انتقال موارد استفاده</div>
          <button onClick={onClose} style={ui.closeBtn}>✕</button>
        </div>

        <div style={ui.mBody}>
          {/* اطلاعات منبع فعلی */}
          <div style={box}>
            <div style={{fontWeight:'700', color:'#1a2f50', marginBottom:'6px', fontSize:'13px'}}>منبع فعلی:</div>
            <div style={{fontSize:'14px', color:'#333'}}>{creditTitle || `شناسه ${creditId}`}</div>
          </div>

          {loading ? (
            <div style={{textAlign:'center', padding:'20px', color:'#888'}}>⏳ در حال بررسی موارد استفاده...</div>
          ) : done ? (
            <div style={successBox}>
              <div style={{fontSize:'28px', marginBottom:'8px'}}>✅</div>
              <div style={{fontWeight:'700', color:'#1b5e20', fontSize:'14px'}}>
                انتقال با موفقیت انجام شد — {toFarsi(changed)} مورد تغییر یافت
              </div>
            </div>
          ) : !usable ? (
            <div style={{...box, background:'#fff3e0', borderColor:'#ffcc80'}}>
              <div style={{color:'#e65100', fontWeight:'700'}}>هیچ مورد استفاده‌ای یافت نشد</div>
            </div>
          ) : (
            <>
              {/* تعداد موارد استفاده */}
              <div style={{display:'flex', gap:'14px', marginTop:'10px'}}>
                <div style={countBox}>
                  <div style={{fontSize:'11px', color:'#888'}}>این سال مالی</div>
                  <div style={{fontSize:'20px', fontWeight:'700', color:'#1a237e'}}>{toFarsi(countYear)}</div>
                </div>
                <div style={countBox}>
                  <div style={{fontSize:'11px', color:'#888'}}>کل سال‌ها</div>
                  <div style={{fontSize:'20px', fontWeight:'700', color:'#b71c1c'}}>{toFarsi(countAll)}</div>
                </div>
              </div>

              {/* انتخاب محدوده */}
              <div style={{marginTop:'14px', display:'flex', gap:'16px', alignItems:'center'}}>
                <label style={radioLbl}>
                  <input type="radio" checked={thisYear} onChange={()=>setThisYear(true)} />
                  فقط سال {toFarsi(year)}
                </label>
                <label style={radioLbl}>
                  <input type="radio" checked={!thisYear} onChange={()=>setThisYear(false)} />
                  تمام سال‌ها
                </label>
              </div>

              {/* جستجوی جایگزین */}
              <div style={{marginTop:'16px'}}>
                <label style={ui.mlabel}>منبع اعتباری جایگزین:</label>
                <input value={q} onChange={e=>{ setQ(e.target.value); setTarget(null); }}
                  placeholder="کد یا عنوان منبع جایگزین را تایپ کنید..."
                  style={{...ui.input, marginTop:'4px'}} />
                {searching && <div style={{fontSize:'11px', color:'#888', marginTop:'4px'}}>⏳ جستجو...</div>}
                {results.length > 0 && !target && (
                  <div style={dropdown}>
                    {results.map(r => (
                      <div key={r.id} style={dropItem} onClick={()=>{ setTarget(r); setQ(r.display); setResults([]); }}>
                        {r.display}
                      </div>
                    ))}
                  </div>
                )}
                {target && (
                  <div style={selectedTarget}>
                    ✅ انتخاب شده: <strong>{target.display}</strong>
                  </div>
                )}
              </div>

              {error && <div style={{...ui.errBox, marginTop:'10px'}}>⚠️ {error}</div>}
            </>
          )}
        </div>

        <div style={ui.mFooter}>
          <button onClick={onClose} style={ui.btnCancel}>{done ? 'بستن' : 'انصراف'}</button>
          {usable && !done && (
            <button onClick={doMove} disabled={saving || !target} style={{...ui.btnSave, background:'#1a237e', opacity: target?1:0.4}}>
              {saving ? '⏳ در حال انتقال...' : '🔄 انتقال'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

const box = { background:'#f5f7fa', border:'1px solid #e8eaf6', borderRadius:'10px', padding:'12px 16px' };
const countBox = { flex:1, background:'#fff', border:'1px solid #e0e0e0', borderRadius:'10px', padding:'12px', textAlign:'center' };
const radioLbl = { display:'flex', alignItems:'center', gap:'4px', fontSize:'13px', color:'#333', cursor:'pointer' };
const dropdown = { background:'#fff', border:'1px solid #ddd', borderRadius:'8px', maxHeight:'190px', overflowY:'auto', marginTop:'4px', boxShadow:'0 6px 20px rgba(0,0,0,0.18)' };
const dropItem = { padding:'8px 12px', fontSize:'12px', cursor:'pointer', borderBottom:'1px solid #f5f5f5', textAlign:'right' };
const selectedTarget = { marginTop:'8px', padding:'8px 12px', background:'#e8f5e9', border:'1px solid #a5d6a7', borderRadius:'8px', fontSize:'13px', color:'#1b5e20' };
const successBox = { textAlign:'center', padding:'30px', background:'#e8f5e9', border:'1px solid #a5d6a7', borderRadius:'10px', marginTop:'10px' };
